import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/zan.png';
import _imports_1 from '../../assets/image/look.png';
import _imports_2 from '../../assets/image/commont.png';
const _withScopeId = n => (_pushScopeId("data-v-1f70198e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "forums"
};
const _hoisted_2 = {
  class: "forum"
};
const _hoisted_3 = {
  class: "list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "dmbp_user_l"
};
const _hoisted_6 = {
  class: "logo"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "tiems"
};
const _hoisted_11 = {
  class: "titles"
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "user_info"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
import nav_header from '@/components/nav_header.vue';
import search from '@/components/search.vue';
import { article_type, article_index } from '../../util/http.js';

import { useRouter } from 'vue-router';
import { ref, reactive, onBeforeMount } from 'vue';
export default {
  __name: 'forumSearch',
  setup(__props) {
    const router = useRouter();
    const loading = ref(false);
    const finished = ref(false);
    let page = ref(1);
    let typeId = ref('1');
    let activeIndex = ref(0);
    let datas = reactive({
      forumData: [],
      content: ''
    });
    let forumDesc = data => {
      router.push({
        path: `/detail/${data.id}/0`
      });
    };
    onBeforeMount(() => {
      // article_type().then(res=>{

      //     typeList.value = res.data;
      //     typeId.value = res.data[0].id;
      //     articleIndex(typeId.value,page.value)

      // })   
    });
    // let fnType = (id,index)=>{
    //     datas.forumData.length = 0;
    //     activeIndex.value = index;
    //     page.value = 1
    //     articleIndex(id,page.value)
    // }
    let onSubmit = data => {
      page.value == 1;
      datas.forumData.length = 0;
      datas.content = data;
      articleIndex(data, 1);
    };
    let articleIndex = (content, page) => {
      article_index({
        search: content,
        page: page
      }).then(res => {
        let data = res.data.data;
        if (data.length == '0') {
          finished.value = true;
        } else {
          loading.value = false;
          data.forEach(item => {
            item.image = item.username.avatar;
            item.nickname = item.username.nickname;
            datas.forumData.push(item);
          });
        }
      });
    };
    const onLoad = () => {
      // let tims = setTimeout(()=>{
      if (datas.content != '') {
        articleIndex(datas.content, page.value);
        page.value++;
      } else {
        finished.value = true;
      }

      // },500)
    };

    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(nav_header, {
        name: "搜索"
      }), _createVNode(search, {
        onSubmit: _unref(onSubmit)
      }, null, 8, ["onSubmit"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(datas).forumData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: $event => _unref(forumDesc)(item)
          }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
            src: item.image,
            alt: "",
            srcset: ""
          }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(item.nickname), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.create_time), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", {
            class: "boxCont",
            innerHTML: item.content
          }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", null, [_hoisted_14, _createElementVNode("span", null, _toDisplayString(item.like) + " 赞", 1)]), _createElementVNode("p", null, [_hoisted_15, _createElementVNode("span", null, _toDisplayString(item.browse), 1)]), _createElementVNode("p", null, [_hoisted_16, _createElementVNode("span", null, _toDisplayString(item.comment_count) + "评论", 1)])])], 8, _hoisted_4);
        }), 128))])]),
        _: 1
      }, 8, ["loading", "finished"])])]);
    };
  }
};